import API from 'services/api';

interface IPayload {
  freeCancellation: boolean;
  retryFailedRequest: boolean;
}

interface IReportNoShowResponse {
  success: boolean;
  message: string;
}

export const reportNoShow = ({
  calculationId,
  payload,
}: {
  calculationId: string;
  payload: IPayload;
}): Promise<IReportNoShowResponse> =>
  API.post(`/api/accommodation/calculations/${calculationId}/booking/report-no-show`, payload).then(
    response => response?.data,
  );
